<template>
    <div>
        <div v-if="linjerLoaded && itemsLoaded" class="product-grid product-grid__wrapper">
            <div v-for="item in store.methods.filterLinje(this)" :key="item.id" class="product-grid product-grid__product" @click="store.methods.chooseLinje(item, this, true, true)" :class="[(store.state.numberOfProductsFor2xGrid.includes(linjer.length)) ? 'product-grid__product--two-grid' : 'product-grid__product--three-grid']">
                <div class="product-grid product-grid__image-container">
                    <div class="product-grid__image-box" :class="[ store.methods.getCheckmarkClass(item, this, true), store.methods.getImageClass('product-grid__image-box--', this) ]">
                        <div class="product-grid__inner-image-wrapper" :class="store.methods.getImageClass('product-grid__inner-image-wrapper--', this)">
                            <img :src="store.methods.getImage(item.id, imageLayout, this, true)" draggable="false" class="product-grid product-grid__image" :class="store.methods.getImageClass('product-grid__image--', this)">
                        </div>
                    </div>
                </div>
                <div class="product-grid product-grid__title" :class="[(chosenLinjeId == item.id ) ? 'product-grid__title--active' : '']">{{item.name}}</div>
            </div>
        </div>
        <div v-else class="loading loading__wrapper">
        </div>
        <slide-up-down class="selection selection__inner" v-model="shouldSlide" :duration="200">
        <div v-if="linjeIsChosen" class="linje linje__text-wrapper">
            <h2 class="linje linje__title">{{store.methods.getText(endpoint, "title", true)}}</h2>
            <p class="linje linje__text">{{store.methods.getText(endpoint, "description", true)}}</p>
            <!-- If any linje is chosen except Mixed-->
            <div v-if="chosenLinjeId != store.state.mixedLinjeId && itemsLoaded" class="product-grid product-grid__wrapper product-grid__wrapper">
                <div v-for="item in this.filteredItems" :key="item.id" class="product-grid product-grid__product" @click="store.methods.chooseProduct(item, this)" :class="[(store.state.numberOfProductsFor2xGrid.includes(filteredItems.length)) ? 'product-grid__product--two-grid' : 'product-grid__product--three-grid']">
                    <div class="product-grid product-grid__image-container">
                        <div class="product-grid__image-box" :class="[ store.methods.getCheckmarkClass(item, this, false, true), store.methods.getImageClass('product-grid__image-box--', this, true) ]">
                            <div class="product-grid__inner-image-wrapper" :class="store.methods.getImageClass('product-grid__inner-image-wrapper--', this, true)">
                                <img :src="store.methods.getImage(item.id, imageLayout, this)" draggable="false" class="product-grid product-grid__image" :class="store.methods.getImageClass('product-grid__image--', this, true)">
                            </div>
                        </div>
                    </div>
                    <div class="product-grid product-grid__title" :class="[(chosenProductIds.includes(item.id) ) ? 'product-grid__title--active' : '']">{{item.title.rendered}}</div>
                </div>
            </div>
            <!-- If Mixed is chosen-->
            <div v-if="chosenLinjeId == store.state.mixedLinjeId && itemsLoaded">
                <div class="product-grid product-grid__spacing">
                    <p><p class="linje linje__text">{{store.methods.getText(endpoint, "title", true, store.state.naturalLinjeId)}}</p></p>
                </div>
                <div class="product-grid product-grid__wrapper product-grid__wrapper--no-border-top">
                    <div v-for="item in this.mixedProducts(store.state.naturalLinjeId)" :key="item.id" class="product-grid product-grid__product" @click="store.methods.chooseProduct(item, this)" :class="[(store.state.numberOfProductsFor2xGrid.includes(this.mixedProducts(store.state.naturalLinjeId).length)) ? 'product-grid__product--two-grid' : 'product-grid__product--three-grid']">
                        <div class="product-grid product-grid__image-container">
                            <div class="product-grid__image-box" :class="[ store.methods.getCheckmarkClass(item, this, false, true), store.methods.getImageClass('product-grid__image-box--', this, true) ]">
                                <div class="product-grid__inner-image-wrapper" :class="store.methods.getImageClass('product-grid__inner-image-wrapper--', this, true)">
                                    <img :src="store.methods.getImage(item.id, imageLayout, this)" draggable="false" class="product-grid product-grid__image" :class="store.methods.getImageClass('product-grid__image--', this, true)">
                                </div>
                            </div>
                        </div>
                        <div class="product-grid product-grid__title" :class="[(chosenProductIds.includes(item.id) ) ? 'product-grid__title--active' : '']">{{item.title.rendered}}</div>
                    </div>
                </div>
                <div class="product-grid product-grid__spacing">
                    <p><p class="linje linje__text">{{store.methods.getText(endpoint, "title", true, store.state.tonadLinjeId)}}</p></p>
                </div>
                <div class="product-grid product-grid__wrapper product-grid__wrapper--no-border-top">
                    <div v-for="item in this.mixedProducts(store.state.tonadLinjeId)" :key="item.id" class="product-grid product-grid__product" @click="store.methods.chooseProduct(item, this)" :class="[(store.state.numberOfProductsFor2xGrid.includes(this.mixedProducts(store.state.tonadLinjeId).length)) ? 'product-grid__product--two-grid' : 'product-grid__product--three-grid']">
                        <div class="product-grid product-grid__image-container">
                            <div class="product-grid__image-box" :class="[ store.methods.getCheckmarkClass(item, this, false, true), store.methods.getImageClass('product-grid__image-box--', this, true) ]">
                                <div class="product-grid__inner-image-wrapper" :class="store.methods.getImageClass('product-grid__inner-image-wrapper--', this, true)">
                                    <img :src="store.methods.getImage(item.id, imageLayout, this)" draggable="false" class="product-grid product-grid__image" :class="store.methods.getImageClass('product-grid__image--', this, true)">
                                </div>
                            </div>
                        </div>
                        <div class="product-grid product-grid__title" :class="[(chosenProductIds.includes(item.id) ) ? 'product-grid__title--active' : '']">{{item.title.rendered}}</div>
                    </div>
                </div>
            </div>
            <div>{{this.updateRendered()}}</div>
        </div>
        </slide-up-down>
    </div>
</template>

<script>

import store from '@/store';
import { inject } from 'vue';
import SlideUpDown from 'vue3-slide-up-down'

export default {
    name: 'Linje',
    setup() {
        const store = inject('store');
        return {
            store
        }
    },
    data() {
        return {
            chosenLinjeId: 0,
            linjeIsChosen: false,
            shouldSlide: false,
            linjer: [],
            items: [],
            chosenProductIds: [],
            linjerLoaded: false,
            itemsLoaded: false,
            filteredItems: []
        }
    },
    props: {
        endpoint: String,
        productEndpoint: String,
        imageLayout: String,
        productImageLayout: String
    },
    components: {
        SlideUpDown
    },
    mounted() {
        const store = inject('store');
        store.state.linjeEndpoint = this.endpoint;
        this.fetchLinjeData(store);
        this.fetchProductData(store);
    },
    methods: {
        async fetchLinjeData(store) {
            let fetchEndpoint = store.state.endpoint + this.endpoint;
            let data = await store.methods.fetchProductData(fetchEndpoint);
            this.linjer = JSON.parse(data);
            this.linjerLoaded = true;
            if (this.itemsLoaded) {
                store.methods.setStepAsLoaded(this);
                setTimeout(this.openFirstStep, 300);
            }
        },
        async fetchProductData(store) {
            let fetchEndpoint = store.state.endpoint + this.productEndpoint;
            let data = await store.methods.fetchProductData(fetchEndpoint);
            this.items = JSON.parse(data);
            this.itemsLoaded = true;
            if (this.linjerLoaded) {
                store.methods.setStepAsLoaded(this);
                setTimeout(this.openFirstStep, 300);
            }
        },
        updateRendered() {
            if (this.linjeIsChosen && store.state.itemsHaveLoaded) {
                this.shouldSlide = true;
            } else {
                this.shouldSlide = false;
            }
            return '';
        },
        openFirstStep() {
            this.$emit('clicked', true)
        },
        updateChosenProductCheckmark(action) {
            if (this.linjeIsChosen) {
                this.$emit('updateChosenProductCheckmark', "add");
            } else {
                this.$emit('updateChosenProductCheckmark', "remove");
            }
        },
        mixedProducts(linjeId) {
            let filteredProducts = [];
            for (const item of this.items) {
                if (item.linjer.includes(linjeId)) {
                    filteredProducts.push(item);
                }
            }
            return filteredProducts;
        }
    }
}
</script>
